export default __webpack_public_path__ + "static/media/525.95354a02.png";